import { render, staticRenderFns } from "./BoxInformationDetail.vue?vue&type=template&id=68f87f96&scoped=true&"
import script from "./BoxInformationDetail.vue?vue&type=script&lang=js&"
export * from "./BoxInformationDetail.vue?vue&type=script&lang=js&"
import style0 from "./BoxInformationDetail.vue?vue&type=style&index=0&id=68f87f96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f87f96",
  null
  
)

export default component.exports